import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from '../services/authService';
import './Logout.css';

const Logout = () => {
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const performLogout = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // Perform logout using authService
        await signOut();
        
        // Show success state
        setLoading(false);
        setSuccess(true);
        
        // Redirect to login after 15 seconds
        setTimeout(() => {
          navigate('/login');
        }, 15000);
        
      } catch (err) {
        // Handle logout error gracefully
        console.error('Logout error:', err);
        setLoading(false);
        setError(err);
        
        // Still redirect to login even on failure
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      }
    };

    performLogout();
  }, [navigate]);

  const handleRedirectNow = () => {
    navigate('/login');
  };

  return (
    <div className="logout-container">
      {/* Background Image */}
      <div className="logout-background">
        <img src="/images/paisaje-1.webp" alt="Patagonia Vital" />
        <div className="logout-background-overlay"></div>
      </div>
      
      <div className="logout-card">
        {/* Logo - matching Login layout */}
        <div className="logout-logo">
          <img 
            src="/images/Logo.png" 
            alt="Patagonia Vital" 
          />
        </div>
        
        {/* Title and subtitle */}
        <h1 className="logout-title">Patagonia Vital</h1>
        <p className="logout-subtitle">Sistema de Gestión</p>
        
        {/* Content */}
        <div className="logout-content">
          {loading && (
            <div className="logout-state loading">
              <div className="logout-spinner"></div>
              <h2 className="logout-message">Cerrando sesión...</h2>
              <p className="logout-description">
                Por favor espera mientras cerramos tu sesión de forma segura.
              </p>
            </div>
          )}

          {success && (
            <div className="logout-state success">
              <div className="logout-checkmark">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                </svg>
              </div>
              <h2 className="logout-message">Sesión cerrada exitosamente</h2>
              <p className="logout-description">
                Redirigiendo al inicio de sesión...
              </p>
              <button 
                onClick={handleRedirectNow}
                className="logout-redirect-btn"
              >
                Ir al inicio de sesión ahora
              </button>
            </div>
          )}

          {error && (
            <div className="logout-state error">
              <div className="logout-error-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
              <h2 className="logout-message">Redirigiendo al inicio de sesión</h2>
              <p className="logout-description">
                Tu sesión ha sido cerrada. Serás redirigido en unos momentos.
              </p>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="logout-footer">
          <p className="logout-copyright">
            © {new Date().getFullYear()} Patagonia Vital. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Logout;
